const messages = {
  title: "Negozio",
  description: "Benvenuti al negozio dei premi. Qui puoi riscattare i tuoi punti Bridgestone Plus <br/> per ottenere premi di varie categorie. La gamma di prodotti <br/> viene aggiornata regolarmente. Ci auguriamo che la navigazione sia di vostro gradimento.",
  sort: {
    asc: "Ordina per: prezzo più basso",
    desc: "Ordina per: prezzo più alto",
  },
  productSearchBox: {
    from: "punti da",
    to: "punti a",
  },
  noProducts: "I criteri di ricerca non hanno prodotto risultati",
  quantity: "Quantità",
  search: "Cerca",
  perPage: "Articoli per pagina",
  timeUnavailable: "Attualmente non disponibile",
  product: "Prodotto",
  cart: {
    pointsPerUnit: "Punti per unità",
    pointsSum: "Somma punti",
  },
  action: "Azione",
  pointsTotal: "Totale",
  cartRemainPoints: "Punti restanti nel carrello",
  shoppingCart: "Carrello",
  emptyCart: "Il carrello è vuoto.",
  attributes: "Attributi",
  selectAddressP: "Seleziona l'indirizzo di consegna",
  orderDelivery: "Indirizzo di consegna",
  selectedProducts: "Prodotti selezionati",
  orderSummary: "Panoramica dell'ordine",
  contactPerson: "Referente",
  selectedAddress: "Indirizzo selezionato",
  order: {
    success: "Grazie! Il suo ordine è andato a buon fine. Riceverà una conferma d'ordine nella sua casella di posta entro pochi minuti.",
    description: "Qui troverà una panoramica dei suoi ordini nel negozio premi.",
    info: "Qui troverà una panoramica dei suoi ordini nel negozio premi.",
    date: "Data dell'ordine",
    number: "N. ordine",
    status: {
      created: "Creato",
      confirm_order: "Conferma ordine",
      ready_for_shipment: "Pronto per la spedizione",
      rejected: "Respinto",
      processed: "Elaborato",
      shipped: "Spedito",
      returned: "Restituito",
      finished: "Completato",
    },
    anyOrder: "Nessun ordine",
    products: "Prodotti",
    quantity_short: "pz",
    itemRemoved: "non consegnabile",
  },
  orders: "Ordini",
  notEnoughPoints: "Punti non sufficienti.",
  statusText: "Stato",
  outOfStock: "Attualmente non disponibile",
  productUnavailable: "Questo prodotto non è più disponibile.",
  deletedProductsTitle: "Prodotti non più disponibili",
  deletedProductsMessage: "I seguenti prodotti non sono più disponibili. Rimuovili dal carrello per continuare.",
  removeSelected: "Rimuovi selezione",
  clearCart: "Svuota carrello",
  removeSelectedConfirm: "Rimuovere i prodotti selezionati dal carrello?",
  clearCartConfirm: "Rimuovere tutti i prodotti dal carrello?",
  incompleteAddress: {
    firstName: "Aggiungi un nome all'indirizzo di consegna",
    lastName: "Aggiungi un cognome all'indirizzo di consegna",
    company: "Aggiungi un nome azienda all'indirizzo di consegna",
    street: "Aggiungi via e numero civico all'indirizzo di consegna",
    postalCode: "Aggiungi un codice postale all'indirizzo di consegna",
    city: "Aggiungi una città all'indirizzo di consegna",
    country: "Aggiungi un paese all'indirizzo di consegna",
    phone: "Aggiungi un numero di telefono all'indirizzo di consegna",
  },
  variant: "Varianti selezionabili",
  placeOrder: "Ordine vincolante",
  toOrderDelivery: "Proseguire con l'indirizzo di consegna",
  toOrderSummary: "Alla panoramica degli ordini",
  productImg: "Immagine del prodotto",
  selectAddressBtn: "Selezionare l'indirizzo",
  perPgae: "Articoli per pagina",
  categories: {
    advertising: {
      title: "Materiale pubblicitario",
      desc: "Partecipate direttamente qui sulla piattaforma e assicuratevi <br/> 40 punti extra per il club dei premi.",
    },
    rewards: {
      title: "Premi esclusivi",
      desc: "Scoprite la gamma di premi su <br/>il nostro centro di formazione o presso la vostra sede.",
    },
    tools: {
      title: "Strumenti per l'officina",
      desc: "Utilizzate i vostri punti per la formazione di terzi <br/> e riducete i costi.",
    },
    trainings: {
      title: "Formazione e istruzione",
      desc: "Scoprite la gamma di premi nel nostro centro di formazione o presso la vostra sede.",
    },
    salesroom: {
      title: "Sala vendite",
      desc: "Allestire la scena nel vostro locale di vendita e offrire ai vostri clienti un soggiorno piacevole.",
    },
    hunter: {
      title: "Hunter",
      desc: "Scambiate i punti con interessanti attrezzature da officina Hunter.",
    },
  },
  bestSold: "I più acquistati",
  seasonal: "Stagionale",
  affordable: "Ci siamo quasi",
  forPoints: "per {points} punti",
  reachedPoints: "Punteggio richiesto raggiunto",
  remainingPoints: "{points} Punti rimanenti",
  favoriteProducts: {
    description: "Qui troverete i prodotti che avete salvato.",
  },
  categoryPageDescriptionFallback: "Materiali per l'officina o altri prodotti di qualità con il logo Bridgestone per la vostra azienda",
};
export default {
  messages,
};
